<template>
  <!-- 视频详情 -->
  <div class="page-research">
    <div class="g-banner">
      <cmpBanner bannerType="9"></cmpBanner>
    </div>
    <div class="g-content-wrap g-pad-top">
      <div class="list2 g-card-list">
        <div class="item g-card-1" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <div class="pic-box">
            <img v-lazy="item.img" alt="">
            <!-- <div class="name-fl">精品</div> -->
            <div class="icon-play"></div>
            <!-- <div class="icon-play" @click="goDetailVideo(item)"></div> -->
          </div>
          <div class="info" style="min-height:auto;">
            <h2>{{item.name}}</h2>
          </div>
        </div>
      </div>

      <!-- 无数据 -->
      <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
        <div class="no-data-bg"></div>
        <p class="txt text-center">暂无数据</p>
      </div>

      <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>

      <cmpVideoDialog ref="cmpVideoDialog"></cmpVideoDialog>
    </div>
  </div>
</template>

<script>
import cmpTab from '@cmp/tab'
import cmpSubTab from '@cmp/tab/sub-tab'
import cmpVideoDialog from '@cmp/video-dialog'
export default {
  components: { cmpTab, cmpSubTab, cmpVideoDialog },
  data() {
    return {
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 9,
      },
      total: 0,
      listLoading: false,
    }
  },
  methods: {
    getDataList() {
      this.listLoading = true
      this.$http
        .get('../singleMuseum/applet/audioVideo/list', {
          ...this.listQuery,
          type: this.$route.query.type
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.result
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()
    },
    goDetail(item) {
      window.open(item.url)
      // this.$refs.cmpVideoDialog.init(item.url, String(item.id))
    },
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.page-research {
  .list3 {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 49%;
      &:not(:nth-child(2n)) {
        margin-right: 2%;
      }
      .pic-box {
        width: 230px;
        height: 300px;
        background: $primary;
        padding: 10px;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
      }
      .info {
        .desc {
          height: 110px;
          overflow: hidden;
        }
      }
    }
  }

  .list4 {
    margin-bottom: 30px;
    position: relative;
    font-size: 14px;
    line-height: 24px;
    color: #595452;
    .child {
      position: relative;
      padding: 30px;
      padding-right: 0;
      border-bottom: solid 1px rgba(#312F2E, 0.2);
      font-size: 24px;
      color: #000000;
      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:before {
          content: '';
          display: block;
          width: 16px;
          height: 16px;
          border: solid 1px $primary;
          border-radius: 100%;
          position: absolute;
        }
        &:before {
          left: 0;
          top: 30px;
        }
        p {
          width: 1200px;
        }
      }
      .author {
        margin-top: 14px;
        color: rgba($color: #000000, $alpha: 0.7)
        // font-size: 14px;
      }
      &:first-child {
        border-top: solid 1px $primary;
      }
      &:last-child {
        border-color: $primary;
      }
      &:hover {
        .title {
          color: $primary;
        }
      }
    }
  }

  .list1 {
    .item {
      .info {
        h2 {
          display: inline-block;
          border-bottom: solid 1px transparent;
        }
      }
      &:hover {
        .info {
          h2 {
            border-bottom: solid 1px #000000;
          }
        }
      }
    }
  }

  .list2 {
    .info {
      .time2 {
        color: $primary;
        margin-top: 10px;
      }
    }
  }
}
</style>

